import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { STORAGE } from '../constants/GlobalConstants';
import { ROUTES } from '../constants/RoutingConstants';
import ActivityLogAPI from '../services/ActivityLogsAPI';

const useRoutingUtils = () => {
  const history = useHistory();

  const goHome = () => history.push(ROUTES.HOME);

  return { goHome };
};

export const redirectLogout = () => {
  const isSupplier = STORAGE.get(STORAGE.USER_INFO)?.supplier;

  const userInfo = STORAGE.get(STORAGE.USER_INFO)
  let request = { User : userInfo.name };

  if(userInfo.employeeEmail.trim().length !== 0){
    request = { User : userInfo.employeeEmail } ;
  }
  
  ActivityLogAPI.registerLogout(request)
  .then( res => {
    STORAGE.clear();

  if (isSupplier) {
    STORAGE.set(STORAGE.LOGOUT, ROUTES.LOGIN.SUPPLIER);
  } else {
    STORAGE.set(STORAGE.LOGOUT, ROUTES.LOGIN.USER);
  }

  window.location.replace(window.location.href = `${window.location.origin}${process.env.REACT_APP_ROUTER_BASENAME}`);
}
  );

  
};

export const renewToken = async () => {
  const token = STORAGE.get(STORAGE.TOKEN).token;

  const newToken = await Axios.get(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SUBDOMAIN}/api/Authenticate/renewToken`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then(({ data }) => data);

  STORAGE.set(STORAGE.TOKEN, newToken);

  return newToken.token;
};

export default useRoutingUtils;
